import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  PdfExport,
  Resize,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import ActionMenu from "../../ActionMenu";

const CONTEXT_MENU_ITEMS = [
  {
    text: "Criar Ponto de Visita",
    id: "editar-localizacao",
    iconCss: "e-icons e-eye",
  },
];

export const PositionsGrid = ({
  gridRef,
  dataSource,
  pageSettings,
  effectiveFields,
  getColumnProps,
  layoutMode,
  gridHeight,
  onContextMenuClick,
  onActionMenuClick,
}) => {
  const renderMoreButton = (rowData) => (
    <ActionMenu
      rowData={rowData}
      onClick={(e) => onActionMenuClick(rowData, e)}
    />
  );

  return (
    <div
      className="positions-grid-shell"
      style={{
        width: layoutMode === "grid-only" ? "100%" : "70%",
        height: gridHeight,
      }}
    >
      <GridComponent
        allowKeyboard={false}
        dataSource={dataSource}
        allowPaging={true}
        ref={gridRef}
        pageSettings={pageSettings}
        locale="pt-BR"
        id="gridcomp"
        cssClass="positions-grid"
        allowSorting={true}
        allowFiltering={false}
        width="100%"
        height="100%"
        allowResizing={true}
        rowHeight={30}
        contextMenuItems={CONTEXT_MENU_ITEMS}
        contextMenuClick={onContextMenuClick}
      >
        <ColumnsDirective>
          {effectiveFields.map((field, index) => (
            <ColumnDirective key={field} {...getColumnProps(field, index)} />
          ))}
          <ColumnDirective
            key="actions"
            headerText="Ações"
            textAlign="Right"
            width="50"
            allowFiltering={false}
            allowSorting={false}
            template={renderMoreButton}
          />
        </ColumnsDirective>
        <Inject
          services={[
            Resize,
            Sort,
            ContextMenu,
            Page,
            ExcelExport,
            Edit,
            PdfExport,
            Filter,
            Toolbar,
          ]}
        />
      </GridComponent>
    </div>
  );
};
